import { Button, Form, Spin } from "antd";
import { useState } from "react";
import CommonInput from "../../../Common/CommonInput";
import {
  dispatchtoast,
  mobilePattern,
  panPattern,
  pincodePattern,
} from "../../../Utils";
import Content from "../../../Common/ReceiptContent";

import ReportDrawer from "../../../Common/ReportDrawer";
import {
  checkDMTKyc,
  doAgentRegistration,
  getGenerateLink,
} from "../../../ApiServices/Apifun";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setselectedTab } from "../../../Store/B2bslice";

const PpiForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const memberServices = useSelector((state) => state.B2B.memberServices);
  const [btnLoading, setBtnLoading] = useState(false);
  const [result, setResult] = useState({ data: null, transaction_id: null });
  const [statusDMTkyc, setStatusDMTkyc] = useState(false);
  const [isChecking, setIsChecking] = useState(true);
  const profiledetail = useSelector((state) => state.B2B.profileDetail);

  const [openReceiptDrawer, setOpenReceiptDrawer] = useState(false);

  const handleRegister = (val) => {
    setBtnLoading(true);
    let formdata = new FormData();
    formdata.append("Name", val.Name);
    formdata.append("Mobile", val.Mobile);
    formdata.append("Email", val.Email);
    formdata.append("Pan_number", val.Pan_number);
    formdata.append("Firm_name", val.Firm_name);
    formdata.append("Address", val.Address);
    formdata.append("Pincode", val.Pincode);
    formdata.append("State", val.State);
    doAgentRegistration(formdata)
      .then((res) => {
        if (res.status) {
          dispatchtoast("Agent Registered Successfully!");
          setStatusDMTkyc(true);
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setBtnLoading(false));
  };

  const handleGenerateLink = () => {
    setBtnLoading(true);
    getGenerateLink()
      .then((res) => {
        if (res.status) {
          const { url, encdata } = res.data;

          const form = document.createElement("form");
          form.method = "POST";
          form.action = url;
          form.target = "_blank";

          const input = document.createElement("input");
          input.type = "hidden";
          input.name = "encdata";
          input.value = encdata;

          form.appendChild(input);
          document.body.appendChild(form);

          form.submit();

          document.body.removeChild(form);
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setBtnLoading(false));
  };

  useEffect(() => {
    dispatch(setselectedTab("19"));
    if (!memberServices.includes("204")) {
      navigate("/not-Available");
    } else {
      checkDMTKyc()
        .then((res) => {
          if (res?.status) {
            const kyc_status = res?.data?.kyc_status;
            {
              kyc_status === "completed"
                ? setStatusDMTkyc(true)
                : setStatusDMTkyc(false);
            }
            setIsChecking(false);
            message.open(messageConfiguration("success", res?.message, 3));
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => setIsChecking(false));
    }
  }, []);

  // const handleFundTransferStatus = () => {
  //   setBtnLoading(true);
  //   getfundTransferStatus()
  //     .then((res) => {
  //       if (res.status) {
  //         window.open(res.data?.url, "_blank");
  //         setBtnLoading(false);
  //       }
  //     })
  //     .catch((err) => console.log(err))
  //     .finally(() => setBtnLoading(false));
  // };
  return (
    <>
      <div className="grid grid-cols-1  place-items-start">
        {isChecking ? (
          <div className="flex justify-center items-center h-64">
            <div></div>
          </div>
        ) : statusDMTkyc ? (
          <div className="prepaid animate-slide-in w-full bg-white shadow-normal rounded-3xl p-5">
            <p className="font-bold text-[15px] mb-2">PPI Dmt</p>
            <div className="flex justify-center items-center m-6">
              <Button
                loading={btnLoading}
                onClick={() => handleGenerateLink()}
                className="bg-primary outline-none border-none text-white"
              >
                Generate Link
              </Button>
            </div>
          </div>
        ) : (
          <div className="prepaid animate-slide-in w-full md:w-1/2 bg-white shadow-normal  rounded-3xl p-5">
            <p className="font-bold text-[15px] mb-2">Agent Registration</p>
            <Form
              name="basic"
              initialValues={{
                remember: true,
                Name: profiledetail?.first_name || "",
                Mobile: profiledetail?.mobile || "",
                Email: profiledetail?.email || "",
                Pan_number: profiledetail?.pan || "",
                Address: profiledetail?.address || "",
              }}
              onFinishFailed={(err) => console.log(err)}
              onFinish={(val) => handleRegister(val)}
            >
              <Form.Item
                name="Name"
                label="Name"
                labelCol={{ span: 24 }}
                rules={[
                  { required: true, message: "Enter Name!" },
                  {
                    whitespace: true,
                    message: "Field cannot contain only blank spaces",
                  },
                  {
                    pattern: /^[A-Za-z\s]+$/,
                    message: "Name must contain only letters",
                  },
                  { min: 3, message: "Name must be at least 3 characters" },
                ]}
              >
                <CommonInput placeholder="Enter Name" name="Name" />
              </Form.Item>

              <Form.Item
                name="Mobile"
                label="Mobile"
                labelCol={{ span: 24 }}
                rules={[
                  { required: true, message: "Enter Mobile number!" },
                  {
                    pattern: mobilePattern,
                    message: "Enter a valid 10-digit mobile number",
                  },
                ]}
              >
                <CommonInput
                  placeholder="Enter Mobile"
                  name="mobile"
                  maxLength={10}
                />
              </Form.Item>

              <Form.Item
                name="Email"
                label="Email"
                labelCol={{ span: 24 }}
                rules={[
                  { required: true, message: "Enter Email!" },
                  { type: "email", message: "Enter a valid email address!" },
                ]}
              >
                <CommonInput placeholder="Enter Email" name="Email" />
              </Form.Item>

              <Form.Item
                name="Pan_number"
                label="PAN Number"
                labelCol={{ span: 24 }}
                rules={[
                  { required: true, message: "Enter PAN!" },
                  {
                    pattern: panPattern,
                    message: "Enter a valid PAN number (e.g., ABCDE1234F)",
                  },
                ]}
              >
                <CommonInput
                  placeholder="Enter PAN"
                  name="Pan_number"
                  maxLength={10}
                />
              </Form.Item>

              <Form.Item
                name="Firm_name"
                label="Firm Name"
                labelCol={{ span: 24 }}
                rules={[
                  { required: true, message: "Enter Firm Name!" },
                  {
                    whitespace: true,
                    message: "Field cannot contain only blank spaces",
                  },
                  {
                    min: 2,
                    message: "Firm Name must be at least 2 characters",
                  },
                ]}
              >
                <CommonInput placeholder="Enter Firm Name" name="Firm_name" />
              </Form.Item>

              <Form.Item
                name="Address"
                label="Address"
                labelCol={{ span: 24 }}
                rules={[
                  { required: true, message: "Enter Address!" },
                  {
                    whitespace: true,
                    message: "Field cannot contain only blank spaces",
                  },
                  { min: 5, message: "Address must be at least 5 characters" },
                ]}
              >
                <CommonInput placeholder="Enter Address" name="Address" />
              </Form.Item>

              <Form.Item
                name="Pincode"
                label="Pincode"
                labelCol={{ span: 24 }}
                rules={[
                  { required: true, message: "Enter Pincode!" },
                  {
                    pattern: pincodePattern,
                    message: "Enter a valid 6-digit pincode",
                  },
                ]}
              >
                <CommonInput
                  placeholder="Enter Pincode"
                  name="Pincode"
                  maxLength={6}
                />
              </Form.Item>

              {/* State */}
              <Form.Item
                name="State"
                label="State"
                labelCol={{ span: 24 }}
                rules={[
                  { required: true, message: "Enter State!" },
                  {
                    whitespace: true,
                    message: "Field cannot contain only blank spaces",
                  },
                  {
                    pattern: /^[A-Za-z\s]+$/,
                    message: "State must contain only letters",
                  },
                ]}
              >
                <CommonInput placeholder="Enter State" name="State" />
              </Form.Item>

              <Form.Item>
                <Button
                  loading={btnLoading}
                  className="w-full bg-primary border-none mt-4"
                  style={{ color: "white" }}
                  htmlType="submit"
                >
                  Register
                </Button>
              </Form.Item>
            </Form>
          </div>
        )}
      </div>

      {/* {openOtpModal && (
        <UpiOtpModal
          setResult={setResult}
          setOpenReceiptDrawer={setOpenReceiptDrawer}
          isOpen={openOtpModal}
          setIsOpen={setOpenOtpModal}
          otherFields={allData}
        />
      )} */}
      {openReceiptDrawer && (
        <ReportDrawer
          title={"PPI Dmt Receipt"}
          open={openReceiptDrawer}
          setOpen={setOpenReceiptDrawer}
          content={<Content data={result} />}
        />
      )}
    </>
  );
};

export default PpiForm;
